var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    width: 24,
    height: 30,
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.364,6.635c-1.561-1.559-4.1-1.559-5.658,0L8.172,11.17c-0.473,0.473-0.733,1.1-0.733,1.77   c0,0.668,0.261,1.295,0.732,1.768c0.487,0.486,1.128,0.73,1.769,0.73c0.64,0,1.279-0.242,1.767-0.73l2.122-2.121   c0.391-0.395,0.586-0.904,0.586-1.414c0-0.512-0.195-1.023-0.586-1.414l-3.536,3.535c-0.193,0.195-0.511,0.195-0.708-0.002   c-0.127-0.127-0.146-0.275-0.146-0.352c0-0.078,0.019-0.227,0.146-0.354l4.535-4.537c0.778-0.779,2.048-0.779,2.83,0   c0.779,0.779,0.779,2.049,0,2.828l-4.537,4.537l-2.535,2.535c-0.779,0.779-2.049,0.779-2.828,0c-0.78-0.779-0.78-2.049,0-2.828   l0.095-0.096c-0.451-0.6-0.702-1.359-0.702-2.125l-0.807,0.807c-1.56,1.559-1.56,4.098,0,5.656c0.779,0.779,1.804,1.17,2.828,1.17   s2.049-0.391,2.828-1.17l7.072-7.072C19.924,10.732,19.924,8.195,18.364,6.635z",
    fill: "#1fb5eb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.170370a8017cc931246b34277f7b15f2.svg";
export { ForwardRef as ReactComponent };